import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FileItem } from "src/app/shared/models";
import { DialogWrapper } from "src/app/shared/services/DialogWrapper";

@Component({
  templateUrl: './dialog-file-info.component.html',
  styleUrls: ['./dialog-file-info.component.scss']
})
export class FileInfoDialogComponent extends DialogWrapper {
  protected file: FileItem;
  protected histId: number;
  protected selectedRows: FileItem[] = [];

  constructor(
    public dialogRef: MatDialogRef<FileInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public matDialogData: {
      file: FileItem;
      histId: number;
    },
  ) {
    super();
    this.selectedRows = [this.matDialogData.file];
    this.file = this.matDialogData.file;
    this.histId = this.matDialogData.histId;
  }
}
